import { createFileRoute, redirect } from '@tanstack/react-router'

import { fetchDocument } from '@/app/route-guards'
import { SCREEN_PATH } from '@/features/documents'
import { screenFor } from '@/lib/domain/status'

/** /documents/$docId opens the screen the document's status calls for (DOC-4). */
export const Route = createFileRoute('/_auth/documents/$docId/')({
  beforeLoad: async ({ context, params }) => {
    const doc = await fetchDocument(context.queryClient, params.docId)
    throw redirect({ to: SCREEN_PATH[screenFor(doc)], params, replace: true })
  },
})
